export const scrollToElement = (idOrElement: string | HTMLElement, extraOffset = 112) => {
  const element = typeof idOrElement === "string" ? document.getElementById(idOrElement) : idOrElement

  if (element) {
    const offset = element.getBoundingClientRect().top - extraOffset

    window.scrollBy({ top: offset, behavior: "smooth" })
  }
}
